import { useEffect, useState } from 'react';

/**
 * Returns `value` after `delayMs` of stillness — i.e. updates from
 * the input only propagate to consumers (TanStack Query keys, etc.)
 * after the user stops typing for `delayMs`. Standard search-on-
 * type pattern.
 *
 * Re-renders on every input change to keep the typed value in the
 * input element responsive; the debounced value is what the caller
 * uses to fire the API request.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);

  return debounced;
}
